import React from "react";
import { FaTelegram, FaWhatsapp, FaFacebook, FaYoutube } from "react-icons/fa";
import { ExternalLink } from "lucide-react";
import Layout, { Breadcrumbs } from "../components/Layout";
import Seo from "../components/Seo";

const crumbs = [
  { name: "Home", path: "/" },
  { name: "Predict Target", path: "/predict-target/" },
];

const CHANNELS = [
  {
    name: "Telegram Channel",
    handle: "Join on Telegram",
    href: "https://t.me/MorningSundayTeer",
    Icon: FaTelegram,
    bg: "linear-gradient(135deg,#2AABEE,#229ED9)",
    testId: "social-telegram",
  },
  {
    name: "WhatsApp Channel",
    handle: "Follow on WhatsApp",
    href: "https://whatsapp.com/channel/0029Vb8MzS9F1YlWpvY4M81x",
    Icon: FaWhatsapp,
    bg: "linear-gradient(135deg,#25D366,#128C7E)",
    testId: "social-whatsapp",
  },
  {
    name: "Facebook Page",
    handle: "Like on Facebook",
    href: "https://www.facebook.com/share/18nZVtunj6/",
    Icon: FaFacebook,
    bg: "linear-gradient(135deg,#1877F2,#0C5AD1)",
    testId: "social-facebook",
  },
  {
    name: "YouTube Channel",
    handle: "Subscribe on YouTube",
    href: "https://youtube.com/@morningteerliveresult?si=EVVZwViXcUBP7RGt",
    Icon: FaYoutube,
    bg: "linear-gradient(135deg,#FF0000,#CC0000)",
    testId: "social-youtube",
  },
];

export default function PredictTarget() {
  return (
    <Layout>
      <Seo
        title="Bhutan Morning Teer – Join Our Social Media Channels"
        description="Join Bhutan Morning Teer on Telegram, WhatsApp, Facebook and YouTube for the fastest daily target updates, live results and predictions."
        path="/predict-target/"
        breadcrumb={crumbs}
      />
      <Breadcrumbs items={crumbs} />

      <div className="mx-auto max-w-xl px-4 py-5">
        <h1 className="text-2xl font-extrabold text-[#10161f] sm:text-3xl">
          Join Our Channels
        </h1>
        <p className="mt-2 text-sm leading-relaxed text-slate-600">
          Follow Bhutan Morning Teer on your favourite platform to get the
          fastest daily target updates, live results and predictions directly.
        </p>

        <div className="mt-6 space-y-3">
          {CHANNELS.map((c) => {
            const Icon = c.Icon;
            return (
              <a
                key={c.name}
                href={c.href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={c.testId}
                className="teer-card flex items-center gap-4 rounded-2xl p-4 text-white shadow-md"
                style={{ background: c.bg }}
              >
                <Icon size={40} className="shrink-0" />
                <div className="min-w-0 flex-1">
                  <div className="text-base font-bold sm:text-lg">{c.name}</div>
                  <div className="text-sm opacity-90">{c.handle}</div>
                </div>
                <ExternalLink size={20} className="shrink-0 opacity-90" />
              </a>
            );
          })}
        </div>

        <p className="mt-6 text-xs text-slate-500">
          Note: These are our official social channels. We never ask for money or
          personal details. Content is for informational purposes only.
        </p>
      </div>
    </Layout>
  );
}
